'use client';

import Gallery from '@/components/common/ui/galleries/Gallery';
import AboutOverview from '@/components/common/ygen/sections/about-overview/AboutOverview';
import BrandList from '@/components/common/ygen/sections/brand-list/BrandList';
import Certificate from '@/components/common/ygen/sections/certificate/certificate';
import ContactForm from '@/components/common/ygen/sections/contact-form/ContactForm';
import CorporateValue from '@/components/common/ygen/sections/corporate-value/CorporateValue';
import CounterSectionCommon from '@/components/common/ygen/sections/counter/CounterSectionCommon';
import Banner from '@/components/common/ygen/sections/hero-banner/Banner';
import ImagePlaceholder from '@/components/common/ygen/sections/image-placeholder/ImagePlaceholder';
import IndustriesList from '@/components/common/ygen/sections/industries-list/IndustriesList';
import IndustryV2 from '@/components/common/ygen/sections/industry-v2/IndustryV2';
import IndustryV3 from '@/components/common/ygen/sections/industry-v3/IndustryV3';
import IndustryV4 from '@/components/common/ygen/sections/industry-v4/IndustryV4';
import Industry from '@/components/common/ygen/sections/industry/Industry';
import InnerBannerDetails from '@/components/common/ygen/sections/inner-banner-details/InnerBannerDetails';
import InnerBanner from '@/components/common/ygen/sections/inner-banner/InnerBanner';
import JobList from '@/components/common/ygen/sections/job-list/JobList';
import Map from '@/components/common/ygen/sections/map/Map';
import OverviewFive from '@/components/common/ygen/sections/overview-five/OverviewFive';
import OverviewSimple from '@/components/common/ygen/sections/overview-simple/OverviewSimple.jsx';
import Partners from '@/components/common/ygen/sections/partners/Partners';
import ProductList from '@/components/common/ygen/sections/product-list/ProductList';
import ScrollAnimation from '@/components/common/ygen/sections/scroll-animation-svg/___ScrollAnimation';
import SolutionList from '@/components/common/ygen/sections/solution-list/SolutionList';
import StockList from '@/components/common/ygen/sections/stock-list/StockList';
import StoriesList from '@/components/common/ygen/sections/stories-list/StoriesList';
import BlogList from '@/components/common/ygen/sections/blog-list/BlogList';
import Sustainability from '@/components/common/ygen/sections/sustain/Sustainability';
import React from 'react';
import Descriptions from '@/components/common/ui/details/Descriptions';
import { Col, Container, Row } from 'react-bootstrap';

const RenderedSection = ({ data, place, typeData, jobData, getIndustryData, getImpactStoriesData, getSolutionData, getProductData, getProductCategoryData, getProductBrandData, blogArticles, blogError }) => {
	let sections_list = data?.sections;


	return (
		<>
			{sections_list?.length > 0 &&
				sections_list.map((item, index) => {
					switch (item?.section_data?.template) {
						case 'hero_banner':
							return <Banner data={item} key={index} />;
						case 'industry_footprint':
							return <Industry getIndustryDataALL={getIndustryData} getImpactStoriesDataALL={getImpactStoriesData} getSolutionDataALL={getSolutionData} mainIndex={index} data={item} key={index} />;
						case 'Certificate':
							return <Certificate id={item?.section_data?.slug} data={item} key={index} />;
						case 'industry_footprintv2':
							return <IndustryV2 getIndustryDataALL={getIndustryData} getImpactStoriesDataALL={getImpactStoriesData} getSolutionDataALL={getSolutionData} version={2} mainIndex={index} data={item} key={index} />;
						case 'industry_footprintv3':
							return <IndustryV3 getIndustryDataALL={getIndustryData} getImpactStoriesDataALL={getImpactStoriesData} getSolutionDataALL={getSolutionData} version={3} color={'#000'} data={item} key={index} mainIndex={index} />;
						case 'partners':
							return <Partners mainIndex={index} data={item} key={index} />;
						case 'partnerv2':
							return <Partners mainIndex={index} version data={item} key={index} />;
						case 'award':
							return <Partners mainIndex={index} award data={item} key={index} />;
						case 'overview_list':
							return <CorporateValue award data={item} key={index} />;
						case 'innerbanner':
							return <InnerBanner data={item} key={index} />;
						case 'banner_with_details':
							return <InnerBannerDetails data={item} key={index} />;
						case 'stories_list':
							return <StoriesList data={item} key={index} />;
						case 'blog_list':
							return <BlogList articles={blogArticles} error={blogError} key={index} />;
						case 'ready_stock_list':
							return <StockList productData={getProductData} categoryData={getProductCategoryData} productBrandData={getProductBrandData} data={item} key={index} />;
						case 'category_list':
							return <ProductList data={item} key={index} />;
						case 'gallery_video':
							return <Gallery data={item} key={index} />;
						case 'about_overview':
							return <AboutOverview data={item} key={index} />;
						case 'corporate_slider':
							return <Sustainability id={item?.section_data?.slug} data={item} key={index} />;
						case 'counter':
							return <CounterSectionCommon data={item} key={index} />;
						case 'contact_form':
							return <ContactForm data={item} key={index} />;
						case 'overview_career':
							return <OverviewFive data={item} key={index} />;
						case 'image_placeholder':
							return <ImagePlaceholder place data={item} key={index} />;
						case 'svg_animation':
							return <ScrollAnimation place data={item} key={index} />;
						case 'image_normal':
							return <ImagePlaceholder version data={item} color={'#EFEFEF'} key={index} />;
						case 'simple_overivew':
							return <OverviewSimple data={item} key={index} />;
						case 'simple_overivew_v_2':
							return <OverviewSimple version data={item} key={index} />;
						case 'job_list':
							return <JobList jobList={jobData} data={item} key={index} mainData={data} />;
						case 'brand_list':
							return <BrandList data={item} key={index} />;
						case 'industries_list':
							return <IndustriesList data={item} list={data} key={index} />;
						case 'solution_list':
							return <SolutionList data={item} key={index} />;
						case 'solution_list_slider':
							return <IndustryV4 getIndustryDataALL={getIndustryData} getImpactStoriesDataALL={getImpactStoriesData} getSolutionDataALL={getSolutionData} version data={item} key={index} />;
						case 'map':
							return <Map data={item} key={index} />;
						case 'description':
							return <>
								<Container>
									<Row>
										<Col lg={12}>
											<Descriptions data={item} />
										</Col>
									</Row>
								</Container>
							</>;
						default:
							return null;
					}
				})}

		</>
	);
};

export default React.memo(RenderedSection);
